"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipFlyoutDefaults = exports.ANIMATION_DURATION = void 0;
const noopCloseRequested = () => undefined;
const tooltipFlyoutDefaults = {
  hasArrow: true,
  offset: {
    distance: 8
  },
  onCloseRequested: noopCloseRequested
};
exports.tooltipFlyoutDefaults = tooltipFlyoutDefaults;
const ANIMATION_DURATION = 500;
exports.ANIMATION_DURATION = ANIMATION_DURATION;
//# sourceMappingURL=tooltipConstants.js.map